import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { branchAPI } from '../api/branchAPI';
interface Branch {
	id: number;
	name: string;
	state: string;
}
interface BranchState {
	branches: Branch[];
	loading: boolean;
	error: string | null;
	lastFetched: number | null;
}
const initialState: BranchState = {
	branches: [],
	loading: false,
	error: null,
	lastFetched: null,
};
// Thunk for fetching branches with caching
export const fetchBranches = createAsyncThunk(
	'branch/fetchBranches',
	async (_, { dispatch, getState }) => {
		const state = getState() as { branch: BranchState };
		const { lastFetched } = state.branch;
		// If we have cached data less than 5 minutes old, return it
		if (lastFetched && Date.now() - lastFetched < 5 * 60 * 1000) {
			return state.branch.branches;
		}
		// @ts-ignore
		const result = await dispatch(branchAPI.endpoints.branchCache.initiate());
		if ('error' in result) {
			throw new Error(result.error?.toString() || 'Failed to fetch branches');
		}
		if (!result.data) {
			throw new Error('No data received from branch cache');
		}
		return result.data;
	}
);
const branchSlice = createSlice({
	name: 'branch',
	initialState,
	reducers: {
		clearBranchCache: (state) => {
			state.lastFetched = null;
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(fetchBranches.pending, (state) => {
				state.loading = true;
				state.error = null;
			})
			.addCase(fetchBranches.fulfilled, (state, action) => {
				state.loading = false;
				state.branches = action.payload;
				state.lastFetched = Date.now();
			})
			.addCase(fetchBranches.rejected, (state, action) => {
				state.loading = false;
				state.error = action.error.message || 'Failed to fetch branches';
			});
	},
});
export const { clearBranchCache } = branchSlice.actions;
export default branchSlice.reducer;
